import { createStore } from './utils';

export type ToastType = 'success' | 'error' | 'info';

export type Toast = {
  id: string;
  message: string;
  type: ToastType;
  visible: boolean;
};

type ToastState = {
  toasts: Toast[];
};

export const useToastStore = createStore<ToastState>('ToastStore', () => ({
  toasts: [],
}));

export const showToast = (message: string, type: ToastType = 'info', duration: number = 3000) => {
  const id = Math.random().toString(36).substring(2, 9);
  
  useToastStore.setState((state) => ({
    toasts: [...state.toasts, { id, message, type, visible: true }],
  }));

  setTimeout(() => {
    hideToast(id);
  }, duration);
};

export const hideToast = (id: string) => {
  useToastStore.setState((state) => ({
    toasts: state.toasts.map((t) => (t.id === id ? { ...t, visible: false } : t)),
  }));

  // Remove from state after animation
  setTimeout(() => {
    useToastStore.setState((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  }, 400);
};
